import React, { useState } from "react";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { authLogin } from "../api/authApi";
import { setCookie } from "../utils/cookieUtils";

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(false);
  const [loginErrorText, setLoginErrorText] = useState();
  const navigate = useNavigate();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      login(); // 엔터 키를 눌렀을 때 로그인 함수 실행
    }
  };

  const login = async () => {
    if (!username || username.trim() === "") {
      setLoginError(true);
      setLoginErrorText("* 아이디를 입력해 주세요.");
      return;
    } else if (!password || password.trim() === "") {
      setLoginError(true);
      setLoginErrorText("* 패스워드를 입력해 주세요.");
      return;
    }

    const data = await authLogin(username, password);
    // 쿠키에 로그인 상태 저장
    console.log("data 어케 생겼닝", data);
    if (data) {
      setCookie("accessToken", `${data.data.token}`);
      navigate("/");
    } else {
      setLoginError(true);
      setLoginErrorText("* 아이디또는 비밀번호가 잘못 되었습니다.");
    }
  };

  return (
    <div className="items-center justify-center text-center min-h-[50vh] min-w-[70vw] md:p-10 h-full font-NotoSansKR">
      <div className="flex items-center justify-center min-h-[70vh] ">
        <div className="w-full max-w-sm p-8 bg-white border-2 shadow-lg rounded-xl">
          <h2 className="mb-6 text-2xl font-bold text-center text-gray-700">로그인</h2>

          {/* 사용자 아이디 입력 */}
          <div className="mb-4">
            <label className="block mb-2 font-medium text-gray-600">아이디</label>
            <input
              type="text"
              id="text"
              placeholder="아이디를 입력하세요"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          {/* 사용자 비밀번호 입력 */}
          <div className="mb-6">
            <label htmlFor="password" className="block mb-2 font-medium text-gray-600">
              비밀번호
            </label>
            <input
              type="password"
              id="password"
              placeholder="비밀번호를 입력하세요"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown} // Enter 키 이벤트 처리
            />
          </div>

          {/* 로그인 실패 메시지 */}
          <div className="mb-4">
            <label htmlFor="text" className={`block mb-2 text-xs text-red-400 ${loginError ? "" : "hidden"}`}>
              {loginErrorText}
            </label>
          </div>

          {/* 로그인 버튼 */}
          <button
            onClick={login}
            className="w-full p-3 font-semibold text-white bg-teal-500 rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-400"
          >
            로그인
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
